function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.015 0.585L18.965 5.525C19.745 6.315 19.745 7.575 18.965 8.365L9.775 17.555C9.02369 18.3042 8.00599 18.7248 6.945 18.7248C5.88401 18.7248 4.86631 18.3042 4.115 17.555L0.585 14.025C-0.195 13.235 -0.195 11.975 0.585 11.185L11.185 0.585C11.975 -0.195 13.235 -0.195 14.015 0.585V0.585ZM1.995 12.605L5.535 16.135C6.315 16.925 7.575 16.925 8.365 16.135L11.895 12.605L6.945 7.655L1.995 12.605V12.605Z",
  fill: "#2E7AE2"
});

var SvgEraser = function SvgEraser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEraser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eraser.67052303.svg";
export { ForwardRef as ReactComponent };